import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GtmService {
  private gtmLoaded = false;

  loadGTM(): void {
    const gtmId = (environment.analytics as any)?.gtmId;

    if (this.gtmLoaded || !gtmId) {
      return;
    }

    (window as any).dataLayer = (window as any).dataLayer || [];
    const dataLayerEvent = {
      event: 'gtm.js'
    };
    dataLayerEvent['gtm.start'] = new Date().getTime();
    (window as any).dataLayer.push(dataLayerEvent);

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    const firstScript = document.getElementsByTagName('script')[0];
    firstScript.parentNode?.insertBefore(script, firstScript);

    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    this.gtmLoaded = true;
  }

  pushEvent(event: any): void {
    if (typeof window !== 'undefined' && (window as any).dataLayer) {
      (window as any).dataLayer.push(event);
    }
  }
}
